import React from "react";
import {Form, Input, Radio, Switch, InputNumber, Select, Upload, Icon, Modal, Card, Row, Col, Button} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from '../../../utils/NHFetch';
import {createUuid,hasAuth} from '../../../utils/NHCore';
import NHSelect from '../../common/NHSelect/index'
import css from './index.css';
const FormItem = Form.Item;

const baseUrlPath = "/fwwgl/shwpgl"; //服务网管理模块路径

/**
 * 生活物品编辑表单
 * @date 2018-03-02 14:00
 * Version: 1.0
 */


function beforeUpload(file) {
    let isImage = false;
    if(file.type == ""){
        if(file.name.indexOf(".png") == -1 && file.name.indexOf(".PNG") == -1 &&
            file.name.indexOf(".jpg") == -1 && file.name.indexOf(".JPG") == -1 &&
            file.name.indexOf(".bpm") == -1 && file.name.indexOf(".BPM") == -1 &&
            file.name.indexOf(".gif") == -1 && file.name.indexOf(".GIF") == -1){
            message.error('只能上传图片文件！');
            isImage = false;
        }else{
            isImage = true;
        }
    }else{
        let valid = file.type.indexOf('image')!=-1;
        if (!valid) {
            message.error('只能上传图片文件！');
        }
        return isImage = valid;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('图片大小不能超过2MB!');
    }
    return isImage && isLt2M;
}



class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            statusList:this.props.statusList,
            previewVisible: false,
            previewImage: '',
            fileList: [],
            bztp:this.props.initFormData.BZTP,
            loading: false,
        }
    }

    handleChange = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            this.props.form.setFieldsValue({bztp:info.file.response.data.bh})
            this.setState({
                bztp:info.file.response.data.bh,
                loading: false,
              })
        }
      }
    beforeUpload = (file)=>{
        if(file.type == ""){
            if(file.name.indexOf(".png") == -1 && file.name.indexOf(".PNG") == -1 &&
                file.name.indexOf(".jpg") == -1 && file.name.indexOf(".JPG") == -1 &&
                file.name.indexOf(".bpm") == -1 && file.name.indexOf(".BPM") == -1 &&
                file.name.indexOf(".gif") == -1 && file.name.indexOf(".GIF") == -1){
                message.error('只能上传图片文件！');
                return false;
            }else{
                return true;
            }
        }else{
            let valid = file.type.indexOf('image')!=-1;
            if (!valid) {
                message.error('只能上传图片文件！');
            }
            return valid;
        }
    }

    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        getFieldDecorator('bztp');
        const initData = this.props.initFormData;
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadProps = {
            name:'file',
            action:'api/docrepo/upload',
            data:{uuid:createUuid(),type:'1'},
            accept:'image/*',
            listType:"picture-card",
            showUploadList:false
        }
        const uploadButton = (
            <div>
              <Icon type={this.state.loading ? 'loading' : 'plus'} />
              <div className="ant-upload-text">Upload</div>
            </div>
          );
        const imageUrl = this.state.imageUrl;
        return (
            <div>
                <Form layout="horizontal">
                        <Card title="基础信息" style={{marginBottom:'24px'}}>
                            <Row>
                                <Col>
                                    <NHFormItem id={"bzmc"} required={true} label={"步骤名称"}
                                                form={this.props.form} initialValue={initData.BZMC}>
                                                <Input  placeholder="请输入步骤名称"/>
                                    </NHFormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <NHFormItem id={"bzsm"} label={"步骤说明"}
                                                form={this.props.form} initialValue={initData.BZSM}>
                                                <Input  placeholder="请输入步骤说明"/>
                                    </NHFormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <NHFormItem id={"pxh"} label={"排序号"} required={true}
                                                form={this.props.form} initialValue={initData.PXH}>
                                                <InputNumber
                                                min={0}
                                                step={1}
                                                />
                                    </NHFormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <NHFormItem id={"zt"} label={"状态"} required={true} valuePropName={'checked'}
                                                form={this.props.form} initialValue={initData.ZTM?(initData.ZTM=='1'?true:false):true}>
                                                <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]}/>
                                    </NHFormItem>
                                </Col>
                            </Row>
                        </Card>
                        <Card title="步骤图片" style={{marginBottom:'24px'}}>
                            <Row gutter={16}>
                                <NHFormItem id={"pic"} form={this.props.form} required={true} initialValue={initData.BZTP}>
                                    <div className="clearfix" style={{textAlign:'center',lineHeight:'39px'}}>
                                    <Upload
                                        {...uploadProps}
                                        beforeUpload={beforeUpload}
                                        onChange={this.handleChange}
                                    >
                                        {this.state.bztp ? <img src={"api/docrepo/download?attachmentId="+this.state.bztp} alt="avatar" /> : uploadButton}
                                    </Upload>
                                    </div>
                                </NHFormItem>
                            </Row>
                        </Card>
                        <div style={{display:'none'}}>
                            <NHFormItem id={"bztp"} label={"步骤图片"} required={true}
                                        form={this.props.form} initialValue={this.state.bztp}>
                                        <Input  placeholder="请上传步骤图片"/>
                            </NHFormItem>
                        </div>
                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/bdlc/EditForm.js